import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=473d57ef&scoped=true&"
import script from "./AppAside.vue?vue&type=script&lang=js&"
export * from "./AppAside.vue?vue&type=script&lang=js&"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=473d57ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d57ef",
  null
  
)

export default component.exports